__turbopack_context__.v({
  "modalRoot": "PrimaryOffers-module__NIvM2a__modalRoot",
  "primaryOffersRoot": "PrimaryOffers-module__NIvM2a__primaryOffersRoot",
  "transitionRoot": "PrimaryOffers-module__NIvM2a__transitionRoot",
});
